import { defaultTo, filter, isEmpty, not, pipe, split } from 'ramda'

export const splitGuidsFromParams = pipe(
  defaultTo(''),
  split(','),
  filter(pipe(isEmpty, not)),
  items => !isEmpty(items) ? items : null
)
